import { render, staticRenderFns } from "./KingdomThumb.vue?vue&type=template&id=c41b2e28&scoped=true"
import script from "./KingdomThumb.vue?vue&type=script&lang=js"
export * from "./KingdomThumb.vue?vue&type=script&lang=js"
import style0 from "./KingdomThumb.vue?vue&type=style&index=0&id=c41b2e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41b2e28",
  null
  
)

export default component.exports